import { render, staticRenderFns } from "./WhatsonView.vue?vue&type=template&id=b2df6dba&scoped=true"
import script from "./WhatsonView.vue?vue&type=script&lang=js"
export * from "./WhatsonView.vue?vue&type=script&lang=js"
import "./WhatsonView.vue?vue&type=style&index=0&id=b2df6dba&prod&lang=scss&scoped=true"
import "./WhatsonView.vue?vue&type=style&index=1&id=b2df6dba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2df6dba",
  null
  
)

export default component.exports